import { render, staticRenderFns } from "./StatisticalData.vue?vue&type=template&id=7a545120&scoped=true&"
import script from "./StatisticalData.vue?vue&type=script&lang=js&"
export * from "./StatisticalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a545120",
  null
  
)

export default component.exports